import React from 'react'
import {
  TextField
} from '@material-ui/core';

const ConditionValue = ({conditionValue, handleChange}) => {
  return (
    <TextField  label="Condition Value"
      variant="outlined"                            
      fullWidth
      name='condition_value'
      margin={'normal'}
      value={conditionValue}
      onChange={({target}) => handleChange(target)}
      type="text" />
  )
}

export default ConditionValue
